export const PortfolioIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#1D1C1C"
      stroke-width="1.35"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="3" y="8" width="7" height="12"></rect>
      <rect x="13" y="4" width="8" height="16"></rect>
    </svg>
  );
};
